import { useDialogs } from './useDialogs';
import { closeDialogWithUnsavedChanges } from '../utils/dialogs';

/** * Custom hook to handle closing a dialog with unsaved changes.
 * The page where this hook is used should be wrapped in a DialogProvider
 * @param {Object} params - Parameters for the hook.
 * @param {boolean} params.isUnsavedChanges - Flag indicating if there are unsaved changes.
 * @param {Function} params.setIsUnsavedChanges - Function to set the unsaved changes state.
 * @param {Function} params.redirectCallback - Callback function to redirect after closing the dialog.
 * @returns {Function} - Function to handle closing the dialog.
 */
export const useCloseDialogWithUnsavedChanges = ({ isUnsavedChanges, setIsUnsavedChanges, redirectCallback }) => {
  const { openDialog, closeDialog } = useDialogs();

  const handleCloseDialog = () => {
    if (isUnsavedChanges) {
      closeDialogWithUnsavedChanges(openDialog, closeDialog, redirectCallback, setIsUnsavedChanges);
    } else {
      redirectCallback();
    }
  };

  return handleCloseDialog;
};
